import { __read, __spread } from "tslib";
import { generateContinuousColorScale } from '@keen.io/charts-utils';
import { theme } from '../theme';
export var calculateColorScale = function (minValue, maxValue, colorMode, steps, colors) {
    if (colorMode === void 0) { colorMode = 'continuous'; }
    if (steps === void 0) { steps = 2; }
    if (colors === void 0) { colors = theme.colors; }
    if (colorMode === 'discrete' && steps > 1) {
        var step_1 = (maxValue - minValue) / steps;
        var domainValues_1 = colors.map(function (_el, idx) {
            return Math.floor(step_1 * idx);
        });
        domainValues_1.push(maxValue);
        return function (value) {
            var stepDomainValues = __spread(domainValues_1);
            stepDomainValues.push(value);
            stepDomainValues.sort(function (a, b) { return a - b; });
            var position = stepDomainValues.indexOf(value);
            var index = position ? position - 1 : position;
            return colors[index];
        };
    }
    return generateContinuousColorScale(minValue, maxValue, steps, colors);
};
